import type { AggResponseData } from '../types';

export const transformAggResponseSubtasksConfig = (
	data: AggResponseData,
): { enabled: boolean } => ({
	enabled: data.jira.isSubtasksEnabled || false,
});
